import { IsBoolean } from "class-validator";

export class UpdateEmailTemplateResult {
    @IsBoolean()
    success: boolean;
}